<template>
  <!-- 添加-编辑健康在线文章 -->
  <div class="container ">
    <div class="vue">
      <div class="header padHorizontal10 flex flexJc-sb flexAi-c">
        <div class="text">{{ title }}</div>
        <div class="padR10">
          <el-button size="mini" @click="goBack" icon="el-icon-back"
            >返回</el-button
          >
        </div>
      </div>
      <div class="content flex">
        <div class="right FZ0875">
          <div class="form flex">
            <span class="text">文章标题</span>
            <el-input
              v-model="formArticles.ar_title"
              size="small"
              placeholder=""
            ></el-input>
          </div>
          <div class="form flex">
            <span class="text">所属栏目</span>
            <el-select
              class=""
              size="small"
              v-model="formArticles.ar_cateid"
              placeholder="请选择"
            >
              <el-option
                v-for="item in columnList"
                :key="item.cateId"
                :label="item.cateName"
                :value="item.cateId"
              >
              </el-option>
            </el-select>
          </div>
          <div class="form flex">
            <span class="text">文章作者</span>
            <el-input
              v-model="formArticles.ar_author"
              size="small"
              placeholder=""
            ></el-input>
          </div>
          <div class="form flex">
            <span class="text">文章内容</span>
            <vue-ueditor-wrap
              class="ueditor"
              v-model="formArticles.arContent"
              :config="myConfig"
            ></vue-ueditor-wrap>
          </div>
        </div>
      </div>
      <div class="footer flex flexAi-c flexJc-c">
        <el-button class="sure" size="small" type="primary" @click="confirmBut"
          >确认</el-button
        >
        <el-button @click="goBack" class="sure" size="small" plain
          >取消</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import VueUeditorWrap from 'vue-ueditor-wrap' // ES6 Module
import { apiUploadByBase64 } from '@/api/uploading'
import {
  apiGetCategorys,
  apiAddArticles,
  apiEditArticles
} from '@/api/articleManage'

let _self
export default {
  name: '',
  props: [''],

  data() {
    return {
      title: '添加文章',
      routeData: '',
      uploadActionUrl: '',
      formArticles: {
        ar_title: '',
        ar_cateid: '',
        ar_author: '',
        arContent: '', // 内容
        ar_description: '', // 简介
        ar_pic: '',
        ar_rem: false,
        ar_on: '100'
      },
      formList: [
        '文章标题不能为空!',
        '所属栏目不能为空!',
        '文章作者不能为空!',
        '产品内容不能为空!'
      ],
      myConfig: {
        UEDITOR_HOME_URL: '/UEditor/',
        serverUrl: '',
        // 工具栏是否可以浮动
        autoFloatEnabled: false
      },
      uploadUrl: '', // 上传地址
      videoFlag: false, //
      columnList: [], // 栏目列表
      fileList: [],
      imageUrl: '',
      dialogVisible: false,
      imageUpload: '',
      disabled: false,
      msg: ''
    }
  },
  components: { VueUeditorWrap },
  computed: {},

  beforeMount() {},

  mounted() {
    _self = this
    this.uploadUrl = this.baseURL + '/upload/upload.do'
    this.myConfig.serverUrl = this.baseURL + '/ueditor/ueditorUpload.do'
    if (this.$route.query.info !== undefined) {
      this.title = '编辑文章'
      _self.routeData = JSON.parse(this.$Base64.decode(this.$route.query.info))
      console.log(this.routeData)
      _self.articleEdut()
    }
    this.GetCategorys()
  },

  methods: {
    goBack() {
      this.$router.go(-1)
    },
    // 编辑
    articleEdut() {
      _self.formArticles.ar_title = _self.routeData.arTitle
      _self.formArticles.ar_cateid = _self.routeData.arCateid
      _self.formArticles.arContent = _self.routeData.arContent
      _self.formArticles.ar_author = _self.routeData.arAuthor
      console.log(_self.formArticles)
    },
    addimageBut() {},
    /**
     * 文件上传-自定义上传行为
     * */
    uploadSectionFile(params, file1) {
      if (_self.fileList.length > 0) {
        this.$message.error('最高可上传一个图片')
        return
      }
      console.log(params)
      console.log(file1)
      const file = params.file
      const fileType = file.type
      const isImage = fileType.indexOf('image') !== -1
      console.log(file)
      const isLt2M = file.size / 1024 / 1024 < 2
      // 这里常规检验，看项目需求而定
      // if (!isImage) {
      //   this.$message.error('只能上传图片格式png、jpg、gif!')
      //   return
      // }
      // if (!isLt2M) {
      //   this.$message.error('只能上传图片大小小于2M')
      //   return
      // }
      // 将图片转成base64
      const reader = new FileReader()
      reader.readAsDataURL(file) // 开始转
      reader.onload = function(e) {
        // const _self = this
        // this.result // 这个就是base64编码了
        this.imageUrl = this.result.split('base64,')[1]
        apiUploadByBase64({
          base64: this.imageUrl,
          path: 'BackstageShop'
        }).then(res => {
          if (res.status === 0) {
            _self.$message({
              message: '图片上传成功',
              type: 'success'
            })
            _self.imageUpload = res.data
            _self.fileList[0] = res.data
          }
        })
        console.log(_self.imageUpload)
        console.log(_self.fileList)
      }
    },
    // 删除文件之前的钩子
    handleRemove(file, fileList) {
      _self.fileList = []
    },
    // 文件超出个数限制时的钩
    handleExceed(file, fileList) {
      console.log(fileList)
      console.log(this.fileList)
      this.$message.error('最高可上传一个图片')
    },
    editorClick(e) {
      // console.log(e)
    },
    // 按钮

    // 确定提交按钮
    confirmBut() {
      if (!this.objNaN(this.formArticles, this.formList)) {
        // 不为空走编辑
        if (this.routeData !== '') {
          apiEditArticles({
            arId: this.routeData.arId,
            arTitle: this.formArticles.ar_title,
            arDescription: this.formArticles.ar_description,
            arAuthor: this.formArticles.ar_author,
            arContent: this.formArticles.arContent,
            arCateid: this.formArticles.ar_cateid,
            arPic: this.formArticles.ar_pic,
            arRem: this.formArticles.ar_rem,
            arOn: this.formArticles.ar_on
          }).then(res => {
            if (res.status === 0) {
              this.$Ms(res.msg)
              this.formArticles = {
                ar_title: '',
                ar_description: '', // 简介
                ar_author: '',
                arContent: '',
                ar_cateid: '',
                ar_pic: '',
                ar_rem: false,
                ar_on: '100'
              }
              this.$router.go(-1)
            }
          })
        } else {
          apiAddArticles({
            arTitle: this.formArticles.ar_title,
            arDescription: this.formArticles.ar_description,
            arAuthor: this.formArticles.ar_author,
            arContent: this.formArticles.arContent,
            arCateid: this.formArticles.ar_cateid,
            arPic: this.formArticles.ar_pic,
            arRem: this.formArticles.ar_rem,
            arOn: this.formArticles.ar_on
          }).then(res => {
            if (res.status === 0) {
              this.$Ms(res.msg)
              this.formArticles = {
                ar_title: '',
                ar_description: '', // 简介
                ar_author: '',
                arContent: '',
                ar_cateid: '',
                ar_pic: '',
                ar_rem: false,
                ar_on: '100'
              }
            }
          })
        }
      }
    },

    // 接口
    // 获取栏目列表
    GetCategorys() {
      apiGetCategorys().then(res => {
        if (res.status === 0) {
          this.columnList = res.data
        }
      })
    }
  },

  watch: {}
}
</script>
<style lang="scss" scoped>
.FZ0875 {
  font-size: 0.875em;
}
.vue {
  height: calc(100vh - 120px);
  background-color: #fff;
  border-left: 2px solid #119685;
  .header {
    line-height: 40px;
    .text {
      text-align: left;
      // font-size: 0.875em;
      color: #119685;
    }
  }
  .content {
    height: calc(100% - 90px);
    padding: 20px;
    width: auto;
    overflow: auto;
    position: relative;
    background: #fff;

    .left {
      width: 30%;
    }
    .right {
      width: 70%;
      .form {
        width: 100%;
        line-height: 3;
        // align-items: center;
        justify-content: flex-start;
        padding-bottom: 10px;
        text-align: right;
        .text {
          width: 12%;
          padding-right: 10px;
        }
        .sure {
          padding: 8px 28px;
        }
        /deep/ .video,
        /deep/ .ueditor {
          width: 88%;
        }
        .video {
          /deep/ .el-upload {
            width: 148px;
            height: 148px;
            border: 1px dashed #c0ccda;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
        .image {
          .addimage {
            height: 100%;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            .el-image {
              width: 30px;
              height: 30px;
            }
            .text {
              padding: 0;
              padding-top: 10px;
              width: 100%;
              line-height: normal;
            }
          }
          //   .left_name {
          //     width: 80px;
          //     height: 80px;
          //     border: 1px solid #e3e3e3;
          //     padding: 6px;
          //     flex-direction: column;
          //     align-items: center;
          //     justify-content: center;
          //     color: #858585;
          //   }
        }
        .el-input,
        .editor,
        .el-select,
        .el-input-number {
          width: 88%;
          /deep/ input {
            text-align: left;
          }
        }
        /deep/ .el-input-number__decrease {
          height: 19px;
        }
        .el-input-number--small {
          line-height: inherit;
        }
      }
    }
  }
  .footer {
    height: 50px;
  }
}
</style>
